/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CoupangUploadFile } from './CoupangUploadFile';
import {
    CoupangUploadFileFromJSON,
    CoupangUploadFileFromJSONTyped,
    CoupangUploadFileToJSON,
    CoupangUploadFileToJSONTyped,
} from './CoupangUploadFile';

/**
 * 
 * @export
 * @interface CoupangUploadFilesVo
 */
export interface CoupangUploadFilesVo {
    /**
     * 订单ID
     * @type {number}
     * @memberof CoupangUploadFilesVo
     */
    orderId?: number;
    /**
     * 订单编码
     * @type {string}
     * @memberof CoupangUploadFilesVo
     */
    orderCode?: string;
    /**
     * 请求类型名称
     * @type {string}
     * @memberof CoupangUploadFilesVo
     */
    requestTypeName?: string;
    /**
     * 请求类型
     * @type {number}
     * @memberof CoupangUploadFilesVo
     */
    requestType?: number;
    /**
     * coupang取货日
     * @type {string}
     * @memberof CoupangUploadFilesVo
     */
    coupangInboundDate?: string;
    /**
     * coupang入库ID
     * @type {string}
     * @memberof CoupangUploadFilesVo
     */
    coupangInboundCode?: string;
    /**
     * coupang公司名称
     * @type {string}
     * @memberof CoupangUploadFilesVo
     */
    coupangCompanyName?: string;
    /**
     * coupang仓库ID
     * @type {number}
     * @memberof CoupangUploadFilesVo
     */
    coupangWarehouseId?: number;
    /**
     * 是否可修改删除 0 不可 1 可
     * @type {number}
     * @memberof CoupangUploadFilesVo
     */
    canChange?: number;
    /**
     * 文件列表
     * @type {Array<CoupangUploadFile>}
     * @memberof CoupangUploadFilesVo
     */
    files?: Array<CoupangUploadFile>;
    /**
     * coupang本地运输方式ID
     * @type {number}
     * @memberof CoupangUploadFilesVo
     */
    krLocalTransportMethodId?: number;
    /**
     * 收货人姓名
     * @type {string}
     * @memberof CoupangUploadFilesVo
     */
    receiverName?: string;
    /**
     * 收货人手机号
     * @type {string}
     * @memberof CoupangUploadFilesVo
     */
    mobileNO?: string;
    /**
     * 收货人邮政编码
     * @type {string}
     * @memberof CoupangUploadFilesVo
     */
    zip?: string;
    /**
     * 收货地址
     * @type {string}
     * @memberof CoupangUploadFilesVo
     */
    receiveAddress?: string;
}

/**
 * Check if a given object implements the CoupangUploadFilesVo interface.
 */
export function instanceOfCoupangUploadFilesVo(value: object): value is CoupangUploadFilesVo {
    return true;
}

export function CoupangUploadFilesVoFromJSON(json: any): CoupangUploadFilesVo {
    return CoupangUploadFilesVoFromJSONTyped(json, false);
}

export function CoupangUploadFilesVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CoupangUploadFilesVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'requestTypeName': json['requestTypeName'] == null ? undefined : json['requestTypeName'],
        'requestType': json['requestType'] == null ? undefined : json['requestType'],
        'coupangInboundDate': json['coupangInboundDate'] == null ? undefined : json['coupangInboundDate'],
        'coupangInboundCode': json['coupangInboundCode'] == null ? undefined : json['coupangInboundCode'],
        'coupangCompanyName': json['coupangCompanyName'] == null ? undefined : json['coupangCompanyName'],
        'coupangWarehouseId': json['coupangWarehouseId'] == null ? undefined : json['coupangWarehouseId'],
        'canChange': json['canChange'] == null ? undefined : json['canChange'],
        'files': json['files'] == null ? undefined : ((json['files'] as Array<any>).map(CoupangUploadFileFromJSON)),
        'krLocalTransportMethodId': json['krLocalTransportMethodId'] == null ? undefined : json['krLocalTransportMethodId'],
        'receiverName': json['receiverName'] == null ? undefined : json['receiverName'],
        'mobileNO': json['mobileNO'] == null ? undefined : json['mobileNO'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'receiveAddress': json['receiveAddress'] == null ? undefined : json['receiveAddress'],
    };
}

export function CoupangUploadFilesVoToJSON(json: any): CoupangUploadFilesVo {
    return CoupangUploadFilesVoToJSONTyped(json, false);
}

export function CoupangUploadFilesVoToJSONTyped(value?: CoupangUploadFilesVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'orderCode': value['orderCode'],
        'requestTypeName': value['requestTypeName'],
        'requestType': value['requestType'],
        'coupangInboundDate': value['coupangInboundDate'],
        'coupangInboundCode': value['coupangInboundCode'],
        'coupangCompanyName': value['coupangCompanyName'],
        'coupangWarehouseId': value['coupangWarehouseId'],
        'canChange': value['canChange'],
        'files': value['files'] == null ? undefined : ((value['files'] as Array<any>).map(CoupangUploadFileToJSON)),
        'krLocalTransportMethodId': value['krLocalTransportMethodId'],
        'receiverName': value['receiverName'],
        'mobileNO': value['mobileNO'],
        'zip': value['zip'],
        'receiveAddress': value['receiveAddress'],
    };
}

